import { ProductFamily, ProductType } from '@chegg/commerce-utils';
import { CSP_PACKAGE_INDEX, CS_PACKAGE_INDEX } from '../views/CartCheckout/constants';
export var getLayoutContent = function getLayoutContent(params) {
  var content = params.content,
    selectedProduct = params.selectedProduct,
    isMultimonthResubscribe = params.isMultimonthResubscribe;
  if (isMultimonthResubscribe) return content;
  var subscriptionInfo = content.subscriptionInfo,
    packages = content.packages,
    comparableValueProps = content.comparableValueProps;
  var CSPValueProps = comparableValueProps === null || comparableValueProps === void 0 ? void 0 : comparableValueProps.find(function (valueProp) {
    return valueProp.productFamily === ProductFamily.BUNDLE;
  });
  var CSValueProps = comparableValueProps === null || comparableValueProps === void 0 ? void 0 : comparableValueProps.find(function (valueProp) {
    return valueProp.productFamily === ProductFamily.CHEGG_STUDY;
  });

  // all data unique to an individual product will change with this condition
  // includes valueProps, devicePolicy, and termsAndConditions
  var selectedProductIndex = selectedProduct.productType === ProductType.BUNDLE ? CSP_PACKAGE_INDEX : CS_PACKAGE_INDEX;
  var selectedProductContents = packages[selectedProductIndex];
  var cspContents = packages[CSP_PACKAGE_INDEX];
  var errorModal = selectedProductContents.errorModal,
    coupon = selectedProductContents.coupon,
    orderSummary = selectedProductContents.orderSummary,
    paymentMethodsHeadingText = selectedProductContents.paymentMethodsHeadingText,
    paymentForm = selectedProductContents.paymentForm,
    paymentErrorModal = selectedProductContents.paymentErrorModal,
    secondaryValueProps = selectedProductContents.valueProps;
  return {
    subscriptionInfo: subscriptionInfo,
    selectedProductContents: selectedProductContents,
    CSPValueProps: CSPValueProps,
    CSValueProps: CSValueProps,
    cspContents: cspContents,
    errorModal: errorModal,
    coupon: coupon,
    orderSummary: orderSummary,
    paymentMethodsHeadingText: paymentMethodsHeadingText,
    paymentForm: paymentForm,
    paymentErrorModal: paymentErrorModal,
    valueProps: secondaryValueProps
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/utils/getLayoutContent.js
// module id = 4711
// module chunks = 11